import { render, staticRenderFns } from "./list-wrapper.vue?vue&type=template&id=00efac56"
import script from "./list-wrapper.vue?vue&type=script&lang=ts"
export * from "./list-wrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00efac56')) {
      api.createRecord('00efac56', component.options)
    } else {
      api.reload('00efac56', component.options)
    }
    module.hot.accept("./list-wrapper.vue?vue&type=template&id=00efac56", function () {
      api.rerender('00efac56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/list/list-wrapper.vue"
export default component.exports